import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Service } from './apply-policy.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';
const _ = require('lodash');

@Component({
  selector: 'apply-policy',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./apply-policy.scss')],
  template: require('./apply-policy.html')
})

export class ApplyPolicy {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;
  @Output('onClose') selfClose = new EventEmitter();
  @ViewChild('policyForm') form;

  private subscribeHandler;
  private subscribeHandlerForForm;
  private submitted: boolean = false;
  private active: boolean = true;
  private _selectedObject: Object;
  private isRequestPending: boolean = false;
  private isDataTouchedWhileEditing: boolean = false;
  private isEditMode: boolean = false;
  private warningMsg:string;


  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit(f: NgForm) {
    if(f.valid) {
      let formObj = this.formatRetentionForBE(f.value);
      switch(this.mode) {
        case DataProtectionVariables.POLICY_POPUP_MODES['CREATE_VAPP']:
          this.createVapp(formObj);
          break;
        case DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VAPP']:
          this.updateVapp(formObj);
          break;
        case DataProtectionVariables.POLICY_POPUP_MODES['CREATE_VDC']:
          this.createVDC(formObj);
          break;
        case DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VDC']:
          this.updateVDC(formObj);
          break;
        default :
          this.createVapp(formObj);
      }
    }
  }

  onSubmitButtonClicked(f: NgForm) {
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  //Workaround until form has a reset method
  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
  }

  constructWarningMessage() {
    switch(this.mode) {
        case DataProtectionVariables.POLICY_POPUP_MODES['CREATE_VAPP']:
        case DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VAPP']:
          this.warningMsg = this.translate.instant('dpsModule.applyPolicy.warningVapp');
          break;
        case DataProtectionVariables.POLICY_POPUP_MODES['CREATE_VDC']:
        case DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VDC']:
          this.warningMsg = this.translate.instant('dpsModule.applyPolicy.warningVDC');
          break;
      }
  }

  //Life Cycle Hooks
  ngOnInit() {
    this.resetSelection();
  }

  formElementsChangeListener(values) {
    this.isDataTouchedWhileEditing = true;
    if(this.subscribeHandlerForForm) this.subscribeHandlerForForm.unsubscribe();
  }

  checkEditMode(): boolean {
    return this.mode === DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VAPP'] || this.mode === DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VDC'];
  }

  ngOnChanges(changes) {
    if(changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') ) {
      this.constructWarningMessage();
      this._selectedObject = this.getSelectedObject();
      this.isEditMode = this.checkEditMode();
      if(this._selectedObject.hasOwnProperty('retention') && this._selectedObject['retention'].hasOwnProperty('days'))
        setTimeout((rtn) => this._selectedObject['retention']['days'] = rtn, 100, this._selectedObject['retention']['days']);

        if(this.form && this.form.control && this.form.control.valueChanges && changes.isVisible.currentValue) {
          this.isDataTouchedWhileEditing = false;
          setTimeout((that) => {
              that.subscribeHandlerForForm = that.form.control.valueChanges.subscribe(values => that.formElementsChangeListener(values));
            }, 100, this);
        }
    }
    else {
      this.resetSelection();
    }
  }

  getSelectedObject() {
    var selObj = this.resetSelection();
    switch(this.mode){
      case DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VAPP']:
        if(this.selectedObject && this.selectedObject.constructor === Array && this.selectedObject.length > 0)
            selObj = _.cloneDeep(this.selectedObject[0]);
        break;
      case DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VDC']:
        if(this.selectedVDC && typeof this.selectedVDC === 'object')
            selObj = _.cloneDeep(this.selectedVDC);
        break;
    }
    return selObj;
  }

  resetSelection() {
    return this._selectedObject =
      {
        "id" : "",
        "name" : "",
        "schedule": {
          "startTime" : "00:00:00",
          "timeZone" : "America/Los_Angeles",
          "timeOfDays" : [ {
          "hour" : 0,
          "minutes" : 0,
          "seconds" : 0
          } ],
          "scheduleType" : "Daily"
        },
        "retention" : {
            "days" : 0
        }
      }
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
    if(this.subscribeHandlerForForm) this.subscribeHandlerForForm.unsubscribe();
  }

  formatRetentionForBE(obj) {
    if(obj && obj.hasOwnProperty('retention') && typeof obj.retention !== 'object') {
      obj.retention = {
        "days" : obj.retention
      }
    }
    return obj;
  }

  createVapp(obj) {
    if(this.selectedVDC && this.selectedVDC.id !== '' &&
       this.selectedObject && this.selectedObject[0] && this.selectedObject[0].id && this.selectedObject[0].id !== '') {
         this.isRequestPending = true;
         this.subscribeHandler = this.service.createVapp(this.selectedVDC.id, this.selectedObject[0].id, obj)
          .subscribe(
            res => {
              this.closeSelf();
            },
            error => this.logError(error, 'create vApp'),
            () => this.logOperationCompleted('create vApp')
          );
    }
    else
      this.logError('Incorrect VDC or vApp information');
  }

  updateVapp(obj) {
    if(this.selectedVDC && this.selectedVDC.id !== '' &&
       this.selectedObject && this.selectedObject[0] && this.selectedObject[0].id && this.selectedObject[0].id !== '') {
         this.isRequestPending = true;
         this.subscribeHandler = this.service.updateVapp(this.selectedVDC.id, this.selectedObject[0].id, obj)
          .subscribe(
            res => {
              this.closeSelf();
            },
            error => this.logError(error, 'update vApp'),
            () => this.logOperationCompleted('update vApp')
          );
    }
    else
      this.logError('Incorrect VDC or vApp information');
  }

  createVDC(obj) {
    if(this.selectedVDC && this.selectedVDC.id !== '') {
      this.isRequestPending = true;
      this.subscribeHandler = this.service.createVDC(this.selectedVDC.id, obj)
        .subscribe(
          res => {
            this.closeSelf();
          },
          error => this.logError(error, 'create vdc'),
          () => this.logOperationCompleted('create vdc')
        );
    }
    else
      this.logError('Incorrect VDC information');
  }

  updateVDC(obj) {
    if(this.selectedVDC && this.selectedVDC.id !== '') {
      this.isRequestPending = true;
      this.subscribeHandler = this.service.updateVDC(this.selectedVDC.id, obj)
        .subscribe(
          res => {
            this.closeSelf();
          },
          error => this.logError(error, 'update vdc'),
          () => this.logOperationCompleted('update vdc')
        );
    }
    else
      this.logError('Incorrect VDC information');
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: "close"
      });
    }
  }


  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
    this.isRequestPending = false;
  }

  logOperationCompleted(msg: string) {
    this.isRequestPending = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/apply-policy/apply-policy.component.ts